import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../../../_shared/modal/Modal';
import { Promotion } from '../Promotion.model';
import { ClaimPromotion } from './ClaimPromotion';

interface Props {
  close: () => void;
  isOpen: boolean;
  promotion: Promotion;
}

export function ClaimPromotionDialog({ close, isOpen, promotion }: Props): JSX.Element {
  const { t } = useTranslation();

  return (
    <Modal
      show={isOpen}
      isInfoModal
      data-cy='claim-promo-modal'
      close={close}
      maxWidth={800}
    >
      <h2 className='text-center mb-4'>{t('promotion.modal.title')}</h2>
      <ClaimPromotion promotion={promotion} />
    </Modal>
  );
}
